import './dashboard-page.css';

import { Tag } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useGetLatestIncidentsQuery } from '../../redux/api/incidents';
import { useGetRecentFailedTransmissionLogsQuery } from '../../redux/api/transmission-logs';

const DashboardPage = () => {

    const navigate = useNavigate();
    const { data: incidents } = useGetLatestIncidentsQuery(null);
    const { data: failedTransmissions } = useGetRecentFailedTransmissionLogsQuery(null);

    return (
        <div className="dashboard-page-container">
            <h1>Dashboard</h1>
            <div className="dashboard-content">
                <div className="center-dashboard"></div>
                <div className="footer-dashboard">
                    <div className="widget-panel">
                        <div className="panel-header panel-header-link" onClick={() => navigate('/citations')}>Recent Incidents</div>
                        <div className="panel-content">
                            <div className="incident-list">
                                {incidents?.map((incident: any, index: number) => <div key={index} className="incident-item">
                                    <div className="incident-id">{incident.incidentId}</div>
                                    <div className="department-id">Dept ID: {incident.departmentId}</div>
                                    <div className="court-id">Court ID: {incident.courtId}</div>
                                    <div className="incident-date">{new Date(incident.createdAt + "Z").toLocaleString()}</div>
                                </div>)}
                            </div>
                        </div>
                    </div>
                    <div className="widget-panel">
                        <div className="panel-header panel-header-link" onClick={() => navigate('/transmission-logs')}>Failed Transmissions</div>
                        <div className="panel-content">
                            <div className="failed-transmission-list">
                                {failedTransmissions?.map((log: any, index: number) => <div key={index} className="failed-transmission-item">
                                    <div className="failed-transmission-client">{log.client?.name}</div>
                                    <div className="failed-transmission-status"><Tag color="red">FAIL</Tag></div>
                                    <div className="failed-transmission-date">{new Date(log.occurredAt + "Z").toLocaleString()}</div>
                                </div>)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default DashboardPage;

